import MainComponent from "components/Main";

import { ReactComponent as CloseIcon } from 'icons/components/close.svg';
import { ReactComponent as ErrorIcon } from 'icons/components/notificationAlarm.svg';
import { ReactComponent as OkIcon } from 'icons/components/notificationCheck.svg';

import './index.less';
import './themes/default.less';

const typeIcons = {
    error: <ErrorIcon />,
    success: <OkIcon />,
};

export default class NotifyPopup extends MainComponent {

    constructor(props) {
        super(props);

        this.state = {
            type: "error",
            label: "",
            text: ""
        };
    }

    show(props) {
        this.setState({ ...props, opened: true }, () => {
            const tm = setTimeout(() => {
                clearTimeout(tm);
                this._helper.dom.addClass(this.domNode, "active");
                this.setHideDelay();
            }, 10);
        });
    }

    setHideDelay() {
        clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(() => {
            clearTimeout(this.hideTimer);
            this.hide();
        }, 10000);
    }

    hide() {
        const { type } = this.state;

        this.changeState("opened", false, () => {
            this._helper.dom.removeClass(this.domNode, ["active", type]);
        });
    }

    render() {
        const { opened, type, label, text } = this.state;
        const openedState = opened ? "opened" : "";
        const icon = typeIcons[type] || typeIcons["error"];

        return (
            <div ref={el => this.domNode = el} className={`notifyPopup pos fixed flex rad4 ${type} ${openedState}`} onClick={this.hide.bind(this)}>
                <div className="border"></div>
                <div className="container flex1 flex col minW0">
                    <div className="top flex centerV gap8">
                        {icon}
                        <div className="mainTitle flex1 text blockTitle">{label}</div>
                        <CloseIcon className="hand close" />
                    </div>
                    {!!text && <div className="mainText flex1 text p1 hidden">{text}</div>}
                </div>
            </div>
        );
    }
}
